import { Link as MuiLink, LinkProps as MuiLinkProps } from "@mui/material";
import { Link as RouterLink, LinkProps as RouterLinkProps } from "react-router";

type Props = MuiLinkProps & RouterLinkProps;

export function Link({ children, ...props }: Props) {
  return (
    <MuiLink component={RouterLink} {...props}>
      {children}
    </MuiLink>
  );
}
